export const OFFER_VERSION = 'criar_musica_preview_v2';
export const VIDEO_PHOTO_LIMITS = Object.freeze({ min: 1, max: 10 });

export const PLANS = Object.freeze({
  song: Object.freeze({
    id: 'song',
    name: 'Canção Personalizada',
    priceCents: 3990,
    deliveryLabel: 'liberação após o pagamento',
    shortDescription: 'A letra escolhida por você, cantada no estilo e na voz que selecionou.',
    benefits: Object.freeze([
      'Música completa e 100% personalizada',
      'A letra que você aprovou',
      'Nome e história cantados na música',
      'MP3 em alta qualidade',
      'Entrega por e-mail e, se informado, WhatsApp',
    ]),
    includedAddons: Object.freeze([]),
  }),
  song_video: Object.freeze({
    id: 'song_video',
    name: 'Canção Personalizada + Vídeo com Fotos',
    priceCents: 4990,
    deliveryLabel: 'vídeo com 1 a 10 fotos',
    shortDescription: 'Sua canção completa transformada em um presente visual para compartilhar.',
    badge: 'Mais completo',
    benefits: Object.freeze([
      'Tudo da Canção Personalizada',
      'Vídeo com 1 a 10 fotos',
      'Capa personalizada',
      'Página exclusiva para ouvir e compartilhar',
      'Refação gratuita',
    ]),
    includedAddons: Object.freeze([]),
  }),
});

export const ADDONS = Object.freeze({});
export const PLAN_ORDER = Object.freeze(['song', 'song_video']);
export const ADDON_ORDER = Object.freeze([]);

export function availableAddons(planId) {
  const plan = PLANS[planId];
  if (!plan) return [];
  return ADDON_ORDER.map((id) => ADDONS[id]).filter((addon) => !plan.includedAddons.includes(addon.id));
}

export function addonPriceCents(addonId, planId) {
  return ADDONS[addonId]?.priceCents || 0;
}

export function calculateOrder(planId, addonIds = []) {
  const plan = PLANS[planId];
  if (!plan) throw new Error('invalid_plan');
  const allowed = new Set(availableAddons(planId).map((addon) => addon.id));
  const normalizedAddons = [...new Set(addonIds)].filter((id) => allowed.has(id));
  const addonsTotalCents = normalizedAddons.reduce((sum, id) => sum + addonPriceCents(id, planId), 0);
  return Object.freeze({
    offerVersion: OFFER_VERSION,
    planId,
    planPriceCents: plan.priceCents,
    addonIds: Object.freeze(normalizedAddons),
    addonsTotalCents,
    totalCents: plan.priceCents + addonsTotalCents,
  });
}

export function formatBRL(cents) {
  return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(cents / 100);
}
